import { _Get, _Post } from "./ApiMethods";
import { GET_COMPANIES, EDIT_COMPANY_SUB } from "./Endpoints";
import handleTokenExpiration from "./TokenHelper";

export const handleGetCompanies = async () => {
  try {
    const { data } = await _Get(GET_COMPANIES);
    return data;
  } catch (err) {
    if (err.response.data) {
      if (
        err.response.data &&
        (err.response.data.code === 1302 || err.response.data.code === 1300)
      ) {
        handleTokenExpiration();
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};


export const handleUpdateCompanySub = async (payload) => {
  try {
    const { data } = await _Post(EDIT_COMPANY_SUB, payload);
    return data;
  } catch (err) {
    if (err.response.data) {
      if (
        err.response.data &&
        (err.response.data.code === 1302 || err.response.data.code === 1300)
      ) {
        handleTokenExpiration();
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

